import { ColDef } from 'ag-grid-community';
import React, { useCallback, useRef, useState } from 'react';
import { AgGridTable, AgGridTableRef } from '@shared/components/ui/AgGridTable';
import { usePermissions } from '@shared/hooks/usePermissions';
import { useBlockedShipmentsColumns } from '../../hooks/useAgGridColumns';
import { BlockedShipment } from '../../models/Shipments';

interface BlockedShipmentsAgGridTableProps {
  blockedShipments: BlockedShipment[];
  className?: string;
  selectedColumns?: string[];
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  sorting?: { field: string; direction: 'asc' | 'desc' } | null;
  onSortingChange?: (sorting: { field: string; direction: 'asc' | 'desc' } | null) => void;
  onUnblockShipment?: (blockId: number) => void;
}

export const BlockedShipmentsAgGridTable = React.memo(function BlockedShipmentsAgGridTable({
  blockedShipments,
  selectedColumns = [],
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
  sorting,
  onSortingChange,
  onUnblockShipment,
}: BlockedShipmentsAgGridTableProps) {
  const agGridRef = useRef<AgGridTableRef>(null);

  const { getTeamType } = usePermissions();
  const hasTeamData = getTeamType() === 'tenant_3pl';

  const { filteredColumnDefs } = useBlockedShipmentsColumns({
    hasTeamData,
    selectedColumns,
    onUnblockShipment,
  });

  return (
    <div className="w-full">
      <AgGridTable
        ref={agGridRef}
        data={blockedShipments}
        columnDefs={filteredColumnDefs as ColDef[]}
        height="calc(100vh - 200px)"
        enableSelection={false}
        onGridReady={() => undefined}
        className="rounded-lg shadow-sm"
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        gridOptions={{}}
        sorting={sorting}
        onSortingChange={onSortingChange}
        rowHeight={50}
      />
    </div>
  );
});
